import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createQueryClient, setSessionExpiredHandler } from "./lib/query-client";
import { TRPCProvider, createTrpcProxy, trpcClient } from "./lib/trpc";
import { routeTree } from "./routeTree.gen";
import "./styles.css";

const queryClient = createQueryClient();
const trpc = createTrpcProxy(queryClient);

const router = createRouter({
  routeTree,
  context: { queryClient, trpc },
  // No hover preloading: entering a workspace route switches the active workspace.
  defaultPreload: false,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

setSessionExpiredHandler(() => {
  const here = `${window.location.pathname}${window.location.search}`;
  queryClient.clear();
  void router.navigate({ to: "/sign-in", search: { reason: "expired", redirect: here } });
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <RouterProvider router={router} />
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
